<template>
  <div class="container">
    <form class="needs-validation" id="craft-form" data-toggle="validator" novalidate>
      <div class="form-group-container">
        <div class>
          <div class="col-12 row">
            <div class="col-12 welcome-container pull-left no-gutters">
              <div class="row">
                <div class="col-6">Welcome back, {{user.firstname}}</div>
              </div>
            </div>

            <div class="col-12 pull-left no-gutters">
              <div class="row">
                <div class="col-6 col-lg-2 my-account-item">
                  <router-link class to="/">
                    <i class="fas fa-place-of-worship" aria-hidden="true"></i>
                    <span>Services</span>
                  </router-link>
                </div>
                 <div class="col-6 col-lg-2 my-account-item">
                  <router-link class to="/user/bookings">
                    <i class="fas fa-chair" aria-hidden="true"></i>
                    <span>My bookings</span>
                  </router-link>
                </div>
                
                <div class="col-6 col-lg-2 my-account-item">
                  <a
                    class="href-btn"
                    v-on:click="enableTwoFactorAuthentication()"
                    v-if="!user.twoFactorEnabled"
                  >
                    <i class="fa fa-lock" aria-hidden="true"></i>
                    <span>Enable two factor authentication</span>
                  </a>
                  <a class="href-btn" v-on:click="disableTwoFactorAuthentication()" v-else>
                    <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                    <span>Disable two factor authentication</span>
                  </a>
                </div>
                <div class="col-6 col-lg-2 my-account-item">
                  <router-link class to="/user/change-password">
                    <i class="fa fa-key" aria-hidden="true"></i>
                    <span>Change password</span>
                  </router-link>
                </div>
                <!-- <div class="col-6 col-lg-2 my-account-item">
                  <router-link class to="/admin/events">
                    <i class="fas fa-calendar-alt"></i>
                    <span>Events</span>
                  </router-link>
                </div> -->
                
                <div class="col-6 col-lg-2 my-account-item" v-if="user.isAdmin">
                  <router-link class to="/admin">
                    <i class="fas fa-tools"></i>
                    <span>Admin</span>
                  </router-link>
                </div>

                <div class="col-6 col-lg-2 my-account-item">
                  <router-link class to="/logout">
                    <i class="fas fa-sign-out-alt"></i>
                    <span>Logout</span>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-3 pull-right policy-container-item"></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import { UserService } from "@/services/UserServices/UserService";
import commonMixin from "@/mixins/commonMixin";
import formUpdateMixin from "@/mixins/formUpdateMixin";
import currencyFilter from "@/filters/currencyFilter";
import dateFilter from "@/filters/dateFilter";

export default {
  name: "MyAccount",
  mixins: [formUpdateMixin, commonMixin],
  filters: { currencyFilter, dateFilter },
  props: [],
  components: {},
  data() {
    return {
      updateSuccessful: false,
      id: "",
      loaded: false,
      submitMessage: "",
      user: {
        firstname: "",
        lastname: "",
        lockoutEnd: "",
        accessFailedCount: "",
        isActive: null,
        lockoutEnabled: null,
        twoFactorEnabled: false
      }
    };
  },
  methods: {
    async getCurrentUser() {
      var response = await UserService.getCurrentUser();
      if (typeof response !== "undefined" && response.success) {
        this.user = response.data;
        this.loaded = true;
      }
    },
    async enableTwoFactorAuthentication() {
      var response = await UserService.enableTwoFactorAuthentication();
      this.user = response.data;
      this.loaded = true;
    },
    async disableTwoFactorAuthentication() {
      var response = await UserService.disableTwoFactorAuthentication();
      this.user = response.data;
      this.loaded = true;
    }
  },
  computed: {
    // promoHasValue() {
    //   return this.item.percentageOff > 0 ||
    //     this.item.amountOff > 0 ||
    //     this.item.freeDelivery === "true"
    //     ? 1
    //     : "";
    // }
  },
  created() {
    this.id = this.$route.params.id;

    // setTimeout(() => {
    //   this.init("page-form", this.validations);
    // }, 400);
  },
  mounted() {
    this.getCurrentUser();
  }
};
</script>

<style scoped>

</style>